import { render } from "./cancel-appointment.vue?vue&type=template&id=f3a70c16&scoped=true"
import script from "./cancel-appointment.vue?vue&type=script&lang=js"
export * from "./cancel-appointment.vue?vue&type=script&lang=js"

import "./cancel-appointment.vue?vue&type=style&index=0&id=f3a70c16&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a70c16"]])

export default __exports__